<stby-modal-base class="notice-modal stby-modal--scroll-page" [visible]="visible()">
    <div [class]="'notice-modal notice-modal--' + variant()">
        @switch (variant()) {
            @case ('text-only') {
                <div class="notice-modal__image-wrapper">
                    <ng-container *ngTemplateOutlet="image" />
                </div>
            }
            @case ('image-only') {
                <a
                    [aria-label]="'global.notice_modal.image_aria_label' | translate"
                    [href]="ctaHref()"
                    [routerLink]="ctaRouteTo()"
                    [queryParams]="ctaQueryParams()"
                    (click)="onCtaClick()"
                >
                    <ng-container *ngTemplateOutlet="image" />
                </a>
            }
            @case ('image-and-text') {
                <ng-container *ngTemplateOutlet="image" />
            }
        }
        <ng-template #image>
            <img class="notice-modal__image" alt="" [src]="imageSrc()" (error)="onImageError()" />
        </ng-template>
        @if (hasText()) {
            <div class="notice-modal__text">
                <h1 class="marketing">{{ notice().title }}</h1>
                <p class="body-16 regular">{{ notice().description }}</p>
                @if (hasResolvedCta() && notice().ctaLabel) {
                    <stby-button
                        [label]="notice().ctaLabel"
                        [href]="ctaHref()"
                        [routeTo]="ctaRouteTo()"
                        [queryParams]="ctaQueryParams()"
                        (click)="onCtaClick()"
                    />
                }
            </div>
        }
    </div>
</stby-modal-base>
